var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.role)?_c('FormCard',{attrs:{"config":_vm.general_data},on:{"DataSaved":_vm.UpdateData}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }